module.exports = __webpack_public_path__ + "static/media/bullseye.117b5a20.svg";